import resolveConfig from 'tailwindcss/resolveConfig';
import tailwindConfig from '../../../tailwind.config'; // Fix the path

export const fullConfig = resolveConfig(tailwindConfig);

export type Resolution = 'sm' | 'md' | 'lg' | 'xl' | '2xl';
export function getBreakpointValue(value: Resolution): number {
  return +fullConfig.theme.screens[value].slice(0, fullConfig.theme.screens[value].indexOf('px'));
}

export function getCurrentBreakpoint(): Resolution {
  let currentBreakpoint = 'sm';
  let biggestBreakpointValue = 0;
  for (const breakpoint of Object.keys(fullConfig.theme.screens)) {
    const breakpointValue = getBreakpointValue(breakpoint as Resolution);
    if (breakpointValue > biggestBreakpointValue && window.screen.width >= breakpointValue) {
      biggestBreakpointValue = breakpointValue;
      currentBreakpoint = breakpoint;
    }
  }

  return currentBreakpoint as Resolution;
}

export function doesVisibilityInclude(check: Resolution[]): boolean {
  return check.includes(getCurrentBreakpoint());
}

export function isBreakpointAtLeast(check: Resolution): boolean {
  const current = getCurrentBreakpoint();

  let resolutions: any = { sm: true, md: true, lg: true, xl: true, '2xl': true };
  switch (check) {
    case 'md': {
      resolutions = { md: true, lg: true, xl: true, '2xl': true };
      break;
    }
    case 'lg': {
      resolutions = { lg: true, xl: true, '2xl': true };
      break;
    }
    case 'xl': {
      resolutions = { xl: true, '2xl': true };
      break;
    }
    case '2xl': {
      resolutions = { '2xl': true };
      break;
    }
  }

  return resolutions[current];
}
